import React, { Component } from 'react';
import { Feed,  } from 'semantic-ui-react'
import * as moment from 'moment';

export function ShowSentSms(props){

    return (
        <div>
            <Feed.Event>
                    <Feed.Content>
                        <Feed.User>Last Design SMS Sent:</Feed.User>
                        <Feed.Date>{moment(props.order.designSmsSentMilliseconds).fromNow()}</Feed.Date>
                    </Feed.Content>
                    <Feed.Content>
                        <Feed.User>Chat Opened:</Feed.User>
                        <Feed.Date>{props.order.designChatOpened}</Feed.Date>
                    </Feed.Content>
                </Feed.Event>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/newSite/DesignChat/MiscUiParts.js